import React, { useState, useEffect } from 'react';
import { collection, addDoc, getDocs, deleteDoc, doc } from "firebase/firestore";
import { db } from './../../firebase/firebaseConfig';
import Layout from './Layout';
import PageTitle from '../includes/PageTitle';
import './../css/Login.css'

const AddSubCategoryForm = () => {
  const [subCategoryName, setSubCategoryName] = useState('');
  const [categories, setCategories] = useState([]);
  const [subCategories, setSubCategories] = useState([]);
  const [selectedCategory, setSelectedCategory] = useState('');
  const [error, setError] = useState('');

  useEffect(() => {
    const fetchCategories = async () => {
      const categoriesCollection = collection(db, "Categories");
      const categorySnapshot = await getDocs(categoriesCollection);
      const categoryList = categorySnapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));
      setCategories(categoryList);
    };

    const fetchSubCategories = async () => {
      const subCategoriesCollection = collection(db, "sub_category");
      const subCategorySnapshot = await getDocs(subCategoriesCollection);
      const subCategoryList = subCategorySnapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));
      setSubCategories(subCategoryList);
    };

    fetchCategories();
    fetchSubCategories();
  }, []);

  const validateSubCategoryName = (name) => {
    const trimmedName = name.trim();
    if (trimmedName === '') {
      return 'Sub-category name cannot be empty.';
    }
    return '';
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    // Validate sub-category name
    const validationError = validateSubCategoryName(subCategoryName);
    if (validationError) {
      setError(validationError);
      return;
    }
    
    if (!selectedCategory) {
      setError('Please select a category.');
      return;
    }

    try {
      const newSubCategory = await addDoc(collection(db, "sub_category"), {
        sub_category_name: subCategoryName,
        category: selectedCategory
      });
      alert(`Sub-category "${subCategoryName}" added successfully!`);
      setSubCategories([...subCategories, { id: newSubCategory.id, sub_category_name: subCategoryName, category: selectedCategory }]);
      setSubCategoryName('');
      setSelectedCategory('');
      setError(''); // Clear any previous errors
    } catch (e) {
      console.error("Error adding sub-category: ", e);
      alert('Error adding sub-category.');
    }
  };

  const handleDelete = async (id) => {
    try {
      await deleteDoc(doc(db, "sub_category", id));
      setSubCategories(subCategories.filter(subCategory => subCategory.id !== id));
      alert('Sub-category deleted successfully!');
    } catch (e) {
      console.error("Error deleting sub-category: ", e);
      alert('Error deleting sub-category.');
    }
  };

  const groupedSubCategories = subCategories.reduce((acc, subCategory) => {
    if (!acc[subCategory.category]) {
      acc[subCategory.category] = [];
    }
    acc[subCategory.category].push(subCategory);
    return acc;
  }, {});

  return (
    <>
      <PageTitle title="Add Sub-Category - ALMOSTINVISIBLE" />
      <Layout>
        <h1 className="unbounded">Sub-Category</h1>
        <hr />
        <p className='unbounded fw-bold black-bordered-bottom'>Add Sub-Category</p>
        <form onSubmit={handleSubmit}>
          <div>
                <div className="flex-column">
                    <label className='nunito-2'>Sub-Category Name*</label>
                </div>
                <div className="inputForm">
                    <input
                        type="text"
                        value={subCategoryName}
                        onChange={(e) => setSubCategoryName(e.target.value)}
                        required
                        className="input"
                        style={{fontWeight: "bold"}}
                        placeholder='Enter the name of the sub-category'
                    />
                </div>
                <div className="flex-column mt-3">
                    <label className='nunito-2'>Select Category*</label>
                </div>
                <div className="inputForm">
                    <select
                        value={selectedCategory}
                        onChange={(e) => setSelectedCategory(e.target.value)}
                        required
                        className="input"
                    >
                        <option value="">Select a category</option>
                        {categories.map((category) => (
                            <option key={category.id} value={category.id}>
                                {category.name}
                            </option>
                        ))}
                    </select>
                </div>
                {error && <p className='error-message'>{error}</p>}
          </div>
          <br />
          <button type="submit" className='black-button'>Add Sub-Category</button>
        </form>

        <hr />
        <div className='container'>
            <p className='unbounded fw-bold black-bordered-bottom'>List Of Sub-Categories</p>
            {Object.keys(groupedSubCategories).map((categoryId) => (
              <div key={categoryId}>
                <h3 className='category-heading'>{categories.find(cat => cat.id === categoryId)?.name}</h3>
                <ul>
                  {groupedSubCategories[categoryId].map((subCategory, index) => (
                    <li key={subCategory.id} className='d-flex justify-content-between my-2'>
                      <span>{index + 1}. {subCategory.sub_category_name}</span>
                      <button className='red-button' onClick={() => handleDelete(subCategory.id)}>
                          <svg stroke="currentColor" fill="currentColor" stroke-width="0" viewBox="0 0 16 16" height="1.2em" width="1.2em" xmlns="http://www.w3.org/2000/svg">
                            <path d="M5.5 5.5A.5.5 0 016 6v6a.5.5 0 01-1 0V6a.5.5 0 01.5-.5zm2.5 0a.5.5 0 01.5.5v6a.5.5 0 01-1 0V6a.5.5 0 01.5-.5zm3 .5a.5.5 0 00-1 0v6a.5.5 0 001 0V6z"></path>
                            <path fill-rule="evenodd" d="M14.5 3a1 1 0 01-1 1H13v9a2 2 0 01-2 2H5a2 2 0 01-2-2V4h-.5a1 1 0 01-1-1V2a1 1 0 011-1H6a1 1 0 011-1h2a1 1 0 011 1h3.5a1 1 0 011 1v1zM4.118 4L4 4.059V13a1 1 0 001 1h6a1 1 0 001-1V4.059L11.882 4H4.118zM2.5 3V2h11v1h-11z" clip-rule="evenodd"></path>
                          </svg>    
                          &nbsp; Delete
                      </button>
                    </li>
                  ))}
                </ul>
              </div>
            ))}
        </div>
      </Layout>
    </>
  );
};

export default AddSubCategoryForm;
